<div class="grid">
  <div class="col-12">
    <p-panel header="{{ 'NIVELES.LBL_RANGOSUSUARIOS' | translate}}">
      <h3>{{nombreNivel}}</h3>
      <div class="grid form-group">
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <label>* {{ 'NIVELES.LBL_RANGONIVEL' | translate }}</label>
            <p-dropdown disableTab  id="nivelrango1" name="nivelrango1" [options]="selectNivelRango"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                        required="true"
                        [(ngModel)]="idNivelRango"
                        #ngIdNivelRango1="ngModel"
                        (onChange)="t.filter($event.originalEvent.target.textContent, 'nivelRango', 'equals')"
                        emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && !idNivelRango">
              {{ 'NIVELES.LBL_RANGONIVEL' | translate }} {{ 'LBL_REQUERIDO' | translate }}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <label>* {{ 'NIVELES.LBL_ACCIONES' | translate }}</label>
            <p-dropdown disableTab  id="acciones" name="acciones" [options]="selectAcciones"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                        required="true"
                        [(ngModel)]="idAccion"
                        #idAccionid="ngModel"
                        (onChange)="mostrarOcultarNivelRango()"
                        emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
            ></p-dropdown>
          </div>
        </div>
      </div>
      <div class="grid">
        <div class="col-12 md:col-6 lg:col-6" *ngIf="idAccion===2">
          <div class="div-form">
            <label>* {{ 'NIVELES.LBL_NUEVORANGOASIGNAR' | translate }}</label>
            <p-dropdown disableTab  id="idNivel" name="idNivel" [options]="selectNivelRango2"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                         required="true"
                        [(ngModel)]="idNivelRango2"
                        #ngIdNivelRango2="ngModel"
                        emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && !idNivelRango && idAccion===2">
              {{ 'NIVELES.LBL_NUEVORANGOASIGNAR' | translate }} {{ 'LBL_REQUERIDO' | translate }}
            </div>
          </div>
        </div>

      </div>
      <hr>
      <div class="grid">
        <div class="col-12 md:col-6 lg:col-6">

        </div>
        <div class="col-12 md:col-6 lg:col-6">
          <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
                 (input)="t.filterGlobal($event.target.value, 'contains')"
                 [(ngModel)]="busqueda">
        </div>
      </div>
      <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
          <p-table [columns]="columnas" [loading]="cargangoUsuarios" #dt
                   [rows]="10" [(selection)]="usuariosSeleccionados"
                   [value]="usuarios" dataKey="idUsuario" *ngIf="vertabla"
                   [paginator]="true"  paginatorPosition="bottom">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th style="width: 3em">
                  <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                    class="text-center">
                  {{col.header}}
                  <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr [pSelectableRow]="row">
                <td>
                  <p-tableCheckbox [value]="row"></p-tableCheckbox>
                </td>
                <td>{{row.nivelRango}}</td>
                <td>{{row.nombre}}</td>
                <td>{{row.numeroDocumento}}</td>
                <td>{{row.usuarioSistema}}</td>
                <td class="text-center">
                  <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="columns.length" class="text-center">
                  {{ 'MSG_NOHAYREGISTROS' | translate}}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
      <div class="grid form-footer-buttons">
        <div class="form-group col-12 gap-2" *ngIf="!guardando">
          <button pButton icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate}}" type="button" (click)="atras()"></button>
          <button pButton icon="fa fa-plus" label="{{ 'BTN_GUARDAR' | translate}}" type="button" (click)="aplicandoAcciones()"></button>
        </div>
        <div class="form-group col-12" *ngIf="guardando">
          <i class="fa fa-refresh fa-spin fa-fw"></i>
          <span>{{ 'LBL_GUARDANDO' | translate}}...</span>
        </div>
      </div>
    </p-panel>
  </div>
</div>



